import { render, staticRenderFns } from "./ordersList.vue?vue&type=template&id=aa3f62b6&scoped=true&"
import script from "./ordersList.vue?vue&type=script&lang=js&"
export * from "./ordersList.vue?vue&type=script&lang=js&"
import style0 from "./ordersList.vue?vue&type=style&index=0&id=aa3f62b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3f62b6",
  null
  
)

component.options.__file = "ordersList.vue"
export default component.exports